/** @entrypoint */
import AttachmentBundleControl from "./control";

export default AttachmentBundleControl;
